export { RdLockPageLayout } from './RdLockPageLayout';
